/*
 * @Author: lyx
 * @Date: 2024-08-15 14:25:17
 * @LastEditors: lyx
 * @LastEditTime:  2024-08-15 14:25:17
 * @FilePath: /dbrank_b/src/routes/visualChart31/index.js
 */

import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./index.css";
import Stage from "../components/Stage";
import setChart from "./chart";
import Chart from "../components/Chart";
import { Title29 } from "../components/Titles";
import TooltipDrawer from "../components/TooltipDrawer";
import Form from "./Form";
import DBTable from "../components/DBTable";
import SelectLogo from "../components/SelectLogo";
import { applyThousands } from "../utils";

class P31 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartList: [],
      chartAxis: [],
      chartColorList: []
    };
  }
  getMedian = (numbers) =>{
    console.log(numbers / 2);
    console.log(Math.ceil(numbers / 2));
    return Math.ceil(numbers / 2)
  }
  render() {
    const { chartList, chartAxis, chartColorList } = this.state;
    const width = 1210 / chartList.length;
   
    return (
      <Stage>
        <Title29 pageNumber="2.2">热度 | 安踏VS竞品 传播可见度分析
        </Title29>
        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
              安踏传播可见度最高，为13.55%；但有效内容条数少于李宁、耐克
            </div>
            <div contentEditable className={s.des} style={{marginTop: "44px"}}>
              传播可见度（指有效内容（包括高效内容/顶流内容）在该品牌全部正向与中立内容中所占比例）排名依次为：安踏（<span className={s.emphasis}>13.55%</span>）、lululemon（<span className={s.emphasis}>12.89%</span>）、李宁（<span className={s.emphasis}>11.26%</span>）、361度（<span className={s.emphasis}>10.67%</span>）、阿迪达斯（<span className={s.emphasis}>10.50%</span>）、斐乐（<span className={s.emphasis}>10.35%</span>）、特步（<span className={s.emphasis}>9.40%</span>）、耐克（<span className={s.emphasis}>9.05%</span>）、鸿星尔克（<span className={s.emphasis}>7.77%</span>）。理想情况下，品牌的有效、高效和顶流内容占比应尽可能多，代表品牌传播的内容受到用户广泛关注与积极互动，否则为无效传播。
            </div>
            <div contentEditable className={s.des} style={{marginTop: "10px"}}>
            <span className={s.emphasis}>安踏</span>的顶流内容条数和高效内容条数主要来自小红书（<span className={s.emphasis}>319条</span>）和微信号（<span className={s.emphasis}>108条</span>）。
            </div>
          </div>

          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: "100%", height: "100%" }}
              formContent={
                <Form onChange={(values) => this.setState({ ...values })} />
              }
            >
              <Chart
                isShow
                options={setChart({
                  chartAxis: chartAxis,
                  chartList: chartList,
                  color: chartColorList,
                })}
              />
            </TooltipDrawer>
          </div>
        </div>
        <div contentEditable className={s.explain}>
          数据说明：本页图表数据观测窗口为2023年1月1日-12月31日。数据来源：新闻媒体类（中央级媒体/泛财经媒体/行业媒体/大众媒体）+资讯网媒+新闻客户端（今日头条/一点资讯等）+自媒体平台（微信号等）+社交平台（微博/知乎等）+短视频类（抖音/快手/视频号/B站等）+消费种草社区（小红书/什么值得买/得物App等）+垂类体育社区（虎扑/懂球帝/Keep等）+其它论坛贴吧等。
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P31);



// WEBPACK FOOTER //
// src/routes/visualChart/P31/index.js